import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  OpbouwScholing,
  SpecificatieScholing
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-scholing',
  templateUrl: './spec-scholing.component.html',
  styleUrls: ['./spec-scholing.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class SpecScholingComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

    specScholingFormGroup = this.fb.group<AangifteRapport>({});
    specScholing = {} as AangifteRapport;

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specScholingFormGroup = this.fb.group<AangifteRapport>(({
            specificatieScholing: this.fb.group<SpecificatieScholing>(({
                opbouw: this.fb.group<OpbouwScholing>(({
                    terugbetaaldePrestatiebeursAangever: null as unknown as number,
                    terugbetaaldePrestatiebeursPartner: null as unknown as number,
                    ontvangenVergoedingenAangever: null as unknown as number,
                    ontvangenVergoedingenPartner: null as unknown as number,
                    totaalScholingsaftrek: null as unknown as number,
                    aandeelScholingsaftrek: null as unknown as number,
                    totaleUitgavenAangever: null as unknown as number,
                    drempelAangever: null as unknown as number,
                    aftrekbaarAangever: null as unknown as number,
                    totaleUitgavenPartner: null as unknown as number,
                    drempelPartner: null as unknown as number,
                    aftrekbaarPartner: null as unknown as number,
                } as OpbouwScholing))
            } as SpecificatieScholing))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specScholing = value;
                    this.specScholingFormGroup.patchValue(this.specScholing)
                });
                this.disableFormGroup(this.specScholingFormGroup);
            }
        });
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    protected readonly Object = Object;
}
